module.exports = __webpack_public_path__ + "static/img/12areaB_08.8140fa4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_08.png
// module id = 1100
// module chunks = 1